<template>
    <div class="recommend animated fadeInUp" v-if="showContent" style="animation-duration: .4s">
        <div class="title-bar">
            <div class="title">
                {{currContentMenu.name}}
            </div>
            <div class="op-btn">
                <span @click="changePage(2)"><i class="iconfont icon-jiantouzuo"></i></span>
                <span @click="changePage(1)"><i class="iconfont icon-jiantouyou"></i></span>
            </div>
        </div>
        <swiper :options="swiperOption" ref="contentSwiper">
            <!-- slides -->
            <div class="slide-item" style="background: transparent;width: 100%;"
                 v-if="projectDetails[currContentMenu.media+'_list'].length <=0">
                <loading v-if="loadingContent" color="#fff"></loading>
                <no-data title="暂无内容" v-else color="#fff"></no-data>
            </div>
            <swiper-slide :style="'background-image:url(\''+item.cover_pic+'\')'"
                          class="slide-item pointer"
                          :class="{'file-container':currContentMenu.media == 'files'}"
                          @click.native="preview(index)"
                          v-for="(item,index) in projectDetails[currContentMenu.media+'_list']">
                <file-ext class="file-icon" :icon="item.files[0].extension_name" v-if="currContentMenu.media == 'files'"></file-ext>
                <div class="text-position">
                    <div class="recommend-title">
                        {{item.title}}
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import fileExt from "@/components/file-ext"

    export default {
        name: "content-list",
        components: {fileExt},
        props: {
            project_id: {
                type: String,
                default: ""
            },
        },
        data() {
            return {
                swiperOption: {
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    slidesPerView: 4,
                    spaceBetween: 50,
                    autoplay: false,
                    delay: 1000
                },
                swiper: ""
            }
        },
        methods: {
            changePage: function (type = 1) {
                let swiper = this.$refs.contentSwiper.swiper;
                if (type === 1) {
                    swiper.slideNext();
                } else {
                    swiper.slidePrev();
                }
            },
            preview: function (index) {
                this.$store.commit('setCurrMediaIndex', index);
                this.$store.commit('setShowPreview', true);
                const TYPE = {
                    'images':3,
                    'files':2,
                    'successor':6,
                    'audio':4,
                    'video':4,
                };
                this.$http.addViews(this.projectDetails[this.currContentMenu.media+"_list"][index].id,TYPE[this.currContentMenu.media])
            }
        },
        computed: {
            ...mapGetters([
                'projectOpened', 'media', 'projectDetails', 'showContent', 'loadingContent', 'currContentMenu'
            ]),

        },
    }
</script>

<style scoped lang="less">
    .recommend {
        width: 78.5%;
        position: absolute;
        bottom: 20px;
        left: 200px;
        z-index: 10;
        opacity: 0;
        padding: 10px 30px;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        .title-bar {
            border-left: 4px solid #fff;
            padding-left: 5px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .title {
                color: #fff;
                font-size: 18px;
                font-weight: bolder;
                flex-grow: 1;
            }
            .op-btn {
                text-align: right;
                flex-grow: 1;
                color: #fff;
                font-size: 14px;
                span {
                    display: inline-block;
                    background: #eee;
                    margin-right: 5px;
                    text-align: center;
                    padding: 3px 3px 0 3px;
                    border-radius: 3px;
                    cursor: pointer;
                    i {
                        color: #000;
                    }
                }
            }

        }
    }

    .slide-item {
        background: #fff;
        height: 20vh;
        width: 150px;
        border-radius: 10px;
        background: center center no-repeat;
        background-size: cover;
        position: relative;
        color: #fff;
        overflow: hidden;
        .text-position {
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.5);
            width: 100%;
            padding: 10px;
        }
        .recommend-title {
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 6px;
        }
        .cate {
            font-size: 12px;
        }
    }

    .pointer {
        cursor: pointer;
    }

    .loading {
        animation: loading 2s linear infinite;
        display: inline-block;
        width: 19px;
        height: 19px;
        font-size: 17px;
        text-align: center;
    }
    .file-container{
        border:1px solid #ccc;
    }
    .file-icon{
        width: 100px;
        height: 100px;
        margin: 20px auto;
        display: block;
    }

    @keyframes loading {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>